<div class="flex gap-4 items-center justify-between">
  <strong>{{ label }}</strong>
  <div class="flex gap-7 items-center">
    <sbnb-toggle-buttons [ngModel]="value" (ngModelChange)="updated.emit($event)"></sbnb-toggle-buttons>

    <sbnb-property-update-status
      [edited]="edited"
      [hasAirbnbListing]="hasAirbnbListing"
      [hasBookingListing]="hasBookingListing"></sbnb-property-update-status>
  </div>
</div>
